import { IOption } from '@shared/interfaces';
import { RelationshipEnum } from './types';

export const relationShipOptions: IOption<RelationshipEnum>[] = [
  {
    value: RelationshipEnum.Spousal,
    label: 'Spousal',
  },
  {
    value: RelationshipEnum.Parent,
    label: 'Parent',
  },
  {
    value: RelationshipEnum.Child,
    label: 'Child',
  },
  {
    value: RelationshipEnum.Friend,
    label: 'Friend',
  },
  {
    value: RelationshipEnum.FamilyOther,
    label: 'FamilyOther',
  },
  {
    value: RelationshipEnum.None,
    label: 'None',
  },
];
